export const faqs = [
  ['Is this only for advanced users?', 'No. The system includes beginner, intermediate and advanced options.'],
  ['Do I need a gym?', 'No. Bonus 02 includes home exercise options using bodyweight and simple equipment.'],
  ['Are sets and reps included?', 'Yes. Exercises include sets, reps or time, rest periods and progression guidance.'],
  ['Are complete routines included?', 'Yes. The volumes and bonuses include ready-to-follow routines.'],
  [
    'Can fitness professionals use it?',
    'Yes. It can be used as an exercise reference by fitness professionals working within their scope.',
  ],
  ['How do I receive the material?', 'You receive digital access after purchase.'],
  ['Is this a subscription?', 'No. The $27 USD payment is a one-time payment.'],
  [
    'Does this replace physical therapy or medical care?',
    'No. This is educational exercise material. For diagnosed injuries, recent surgery or medical restrictions, follow the guidance of your treating healthcare professional.',
  ],
] as const
